import { can } from "@/plugins/can";

const temPermissao = (permissions, _to, _from, next) => {
  if (!can(permissions)) {
    next({ name: "NaoAutorizado" });
    return false;
  }
  return true;
};

export default temPermissao;
